<template>
    <div class="feedbackboard-phonemic-consonant">
        <div class="feedbackboard-phonemic-consonant__feature">
            <span class="feedbackboard-phonemic-consonant__feature-name">ÇIKIŞ YERİ</span>
            <div class="feedbackboard-phonemic-consonant__feature-values">
                <BtnOptionFeedback
                    :class="{ 'btn-option-feedback--skipped' : feedbackPlace.answerValue === '' }"
                    :optionText="$t('consonant.place.' + feedbackPlace.correctValue)"/>
                <BtnOptionFeedback
                    v-if="feedbackPlace.correctValue !== feedbackPlace.answerValue
                        && feedbackPlace.answerValue !== ''"
                    class="btn-option-feedback--incorrect"
                    :optionText="$t('consonant.place.' + feedbackPlace.answerValue)"/>
            </div>
        </div>

        <div class="feedbackboard-phonemic-consonant__feature">
            <span class="feedbackboard-phonemic-consonant__feature-name">ÇIKIŞ BİÇİMİ</span>
            <div class="feedbackboard-phonemic-consonant__feature-values">
                <BtnOptionFeedback
                    :class="{ 'btn-option-feedback--skipped' : feedbackManner.answerValue === '' }"
                    :optionText="$t('consonant.manner.' + feedbackManner.correctValue)"/>
                <BtnOptionFeedback
                    v-if="feedbackManner.correctValue !== feedbackManner.answerValue
                        && feedbackManner.answerValue !== ''"
                    class="btn-option-feedback--incorrect"
                    :optionText="$t('consonant.manner.' + feedbackManner.answerValue)"/>
            </div>
        </div>

        <div class="feedbackboard-phonemic-consonant__feature">
            <span class="feedbackboard-phonemic-consonant__feature-name">ÖTÜMLÜLÜK</span>
            <div class="feedbackboard-phonemic-consonant__feature-values">
                <BtnOptionFeedback
                    :class="{ 'btn-option-feedback--skipped' : feedbackVoicing.answerValue === '' }"
                    :optionText="$t('consonant.voicing.' + feedbackVoicing.correctValue)"/>
                <BtnOptionFeedback
                    v-if="feedbackVoicing.correctValue !== feedbackVoicing.answerValue
                        && feedbackVoicing.answerValue !== ''"
                    class="btn-option-feedback--incorrect"
                    :optionText="$t('consonant.voicing.' + feedbackVoicing.answerValue)"/>
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import BtnOptionFeedback from '@/components/BtnOptionFeedback.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            BtnOptionFeedback,
        },

        computed: {
            feedbackPlace(){
                return this.$store.state.feedbackData.place;
            },

            feedbackManner(){
                return this.$store.state.feedbackData.manner;
            },

            feedbackVoicing(){
                return this.$store.state.feedbackData.voicing;
            }
        }
    };
</script>

<style scoped src="@/css/components/feedbackboard-phonemic-consonant.css"></style>